import { PageDsl, PageHeading, SettingsProvider } from '../../../types';
import { SectionFactory } from '../section/base';

export type PageDslOptions = {
  heading: PageHeading;
  sections: SectionFactory[];
  settingsProvider?: SettingsProvider;
};

export class PageDslFactory {
  heading: PageHeading;
  sections: SectionFactory[];
  settings: SettingsProvider;

  constructor(options: PageDslOptions) {
    this.heading = options.heading;
    this.sections = options.sections;
    this.settings = options.settingsProvider;
  }

  build(): PageDsl {
    return {
      heading: this.heading,
      sections: this.sections.map(section => section._build()),
      settings: this.settings || {
        values: {},
        dataSettings: [],
        metadata: {},
      },
    };
  }
}
